interface StatsProps {
  count: number;
}

export function Stats({ count }: StatsProps) {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats-grid">
          <div className="stat">
            <div className="stat-num"><span className="currency">&euro;</span>3.2k</div>
            <div className="stat-label">Saved per month, avg.</div>
          </div>
          <div className="stat">
            <div className="stat-num">14<span style={{ color: "var(--accent)" }}>hrs</span></div>
            <div className="stat-label">Reclaimed weekly</div>
          </div>
          <div className="stat">
            <div className="stat-num">{count.toLocaleString()}</div>
            <div className="stat-label">Founders on waitlist</div>
          </div>
          <div className="stat">
            <div className="stat-num">98<span style={{ fontSize: "28px", color: "var(--accent)" }}>%</span></div>
            <div className="stat-label">Auto-match rate</div>
          </div>
        </div>
      </div>
    </section>
  );
}
